/**
 * Copy for `/metal-resources/references/glossary/`
 * (`src/pages/metal-resources/references/glossary/index.tsx`), shared by both brands: SEO fields
 * and hero text. `GlossaryPageContent` here is the page's site-search entry, listed in
 * `scripts/staticSearch.ts`; the glossary page file exports a different `GlossaryPageContent`
 * (its contact and search labels). The `fr` and `es` SEO entries repeat the English text, and
 * every language's title says "Ryerson", on the STS build too.
 */
import { GlossaryHero } from "@components/Glossary/Page/Page";
import { LanguageContent } from "@components/Shared/model/LanguageContent";
import { MetaContent } from "@components/Shared/model/MetaHead";
import { StaticPageContent } from "@components/Shared/model/StaticPageContent";

/** `MetaHead` content for the glossary page, per language. */
export const GlossaryMetaObject: LanguageContent<MetaContent> = {
	en: {
		title: "Metal Glossary - Glossary of Steel Terms - Ryerson",
		description: `This ever-expanding glossary is your guide to the most commonly used terms and phrases in metal.`,
		url: `/metal-resources/references/glossary`,
		company: true,
	},
	fr: {
		title: "Metal Glossary - Glossary of Steel Terms - Ryerson",
		description: `This ever-expanding glossary is your guide to the most commonly used terms and phrases in metal.`,
		url: `/metal-resources/references/glossary`,
		company: true,
	},
	es: {
		title: "Metal Glossary - Glossary of Steel Terms - Ryerson",
		description: `This ever-expanding glossary is your guide to the most commonly used terms and phrases in metal.`,
		url: `/metal-resources/references/glossary`,
		company: true,
	},
};

/** Hero and search-box copy for `src/components/Glossary/Page/Page.tsx`, per language. */
export const GlossaryHeroContent: LanguageContent<GlossaryHero> = {
	en: {
		title: "Glossary",
		searchPlaceholder: "Search the glossary",
		description:
			"This ever-expanding glossary is your guide to the most commonly used terms and phrases in metal.",
	},
	fr: {
		title: "Glossaire",
		searchPlaceholder: "Rechercher dans le glossaire",
		description:
			"Ce glossaire en constante évolution est votre guide des termes et expressions les plus couramment utilisés dans le domaine du métal.",
	},
	es: {
		title: "Glosario",
		searchPlaceholder: "Buscar en el glosario",
		description:
			"Este glosario en constante expansión es su guía de los términos y frases más utilizados en metal.",
	},
};

/** Site-search entry for the glossary page; the Contentful terms themselves are not in it. */
export const GlossaryPageContent: StaticPageContent = {
	meta: GlossaryMetaObject,
	content: [GlossaryHeroContent],
};
